import moment from 'moment';
import { API } from '../constants/api-urls';
import axios from '../requester';
import { SEARCH_DATE_FORMAT } from 'common/constants/constants';

const formatDate = d => moment(d).format(SEARCH_DATE_FORMAT);
export const getSettingsAudit = async params =>
  axios.get(`${API.AUDIT_PATH}?category=settings`, { params });

export const exportSettingsAudit = async params =>
  axios.get(`${API.AUDIT_PATH}/export`, {
    params: {
      ...params,
      from: formatDate(params?.from),
      to: formatDate(params?.to)
    }
  });
